export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const BASE_IMAGE_URL = process.env.NEXT_PUBLIC_IMAGE_URL;